<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="返回" icon="back" @click="back" />
      <q-breadcrumbs-el
        label="二维码"
        icon="qr_code_2"
        to="/order/qrcode"
      />
    </q-breadcrumbs>

    <q-form id="form" :model="form" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div id="qrcode" class="col-md-6 col-11" style="text-align: center">
          <q-img
            id="qrcode"
            class="q-ma-lg"
            :src="qrcode"
            spinner-color="white"
            :style="{ height: form.width + 'px', width: form.width + 'px' }"
          />
        </div>
      </div>
      <div class="row q-col-gutter-md justify-center">
        <div class="col-md-3 col-11">
          <q-input
            type="number"
            outlined
            v-model.number="form.width"
            label="宽度"
            dense
            clearable
          />
        </div>
      </div>
      <div class="row q-col-gutter-md justify-center">
        <div class="col-md-3 col-11" style="text-align: center">
          <q-btn class="q-ma-lg" type="reset" icon="refresh" color="primary">
            <q-tooltip> 恢复默认 </q-tooltip>
          </q-btn>
          <q-btn class="q-ma-lg" icon="print" color="primary" v-print="print">
            <q-tooltip> 打印二维码 </q-tooltip>
          </q-btn>
          <q-btn
            class="q-ma-lg"
            icon="download"
            color="primary"
            @click="download"
          >
            <q-tooltip> 下载 </q-tooltip>
          </q-btn>
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
import { getOrderItemPlanQRcode } from "@/api/common/qrcode.js";
export default {
  data() {
    return { qrcode: "", form: { width: 430 }, print: "#qrcode" };
  },
  methods: {
    getQRcode() {
      getOrderItemPlanQRcode(this.$route.query).then((res) => {
        this.qrcode = `data:image/png;base64,${res.data.data}`;
      });
    },
    back(){
      this.$router.back();
    },
    reset() {
      this.form.width = 430;
    },
    download() {
      let link = document.createElement("a");
      link.href = this.qrcode;
      link.download = "qrcode.png";
      link.click();
    },
  },
  mounted() {
    this.getQRcode();
  },
};
</script>

<style scoped>
</style>